import React, { useRef } from 'react';
import styled, { keyframes } from 'styled-components';

import PngDownloadButton from './PngDownloadButton';
import { downloadSvgAsPng } from '../../../utils/svgExport';

// Analiz Paneli kart sarmalayıcısı (2026-08-03 kullanıcı isteği): ana paneldeki İK Zekâsı
// kartının çift-katmanlı gradient kenarlık tekniğinin (padding-box kart + border-box gradient,
// bkz. HaIntelligencePanel PanelFrame) "kayan ışık" varyantı — gradient içinde parlak bir
// segment background-position animasyonuyla kenarlık boyunca akar (kayan LED efekti).
// prefers-reduced-motion'da animasyon durur, statik gradient kalır (İK Zekâsı kartıyla aynı
// erişilebilirlik sözleşmesi).
const flow = keyframes`
  0%   { background-position: 0% 50%, 0 0, 0% 50%; }
  100% { background-position: 0% 50%, 0 0, 300% 50%; }
`;

const Frame = styled.div`
  position: relative;
  border: 2px solid transparent;
  border-radius: ${({ theme }) => theme.metrics.radius.large};
  background:
    linear-gradient(
      135deg,
      rgba(2, 145, 239, 0.035) 0%,
      rgba(2, 211, 191, 0.05) 55%,
      rgba(255, 255, 255, 0) 100%
    ) padding-box,
    linear-gradient(${({ theme }) => theme.colors.surface.card}, ${({ theme }) => theme.colors.surface.card}) padding-box,
    linear-gradient(
      100deg,
      ${({ theme }) => theme.colors.primary.main} 0%,
      ${({ theme }) => theme.colors.secondary.main} 35%,
      ${({ theme }) => theme.colors.primary.light} 50%,
      ${({ theme }) => theme.colors.secondary.main} 65%,
      ${({ theme }) => theme.colors.primary.main} 100%
    ) border-box;
  background-size: auto, auto, 300% 100%;
  box-shadow: 0 1px 4px rgba(${({ theme }) => theme.colors.shadow.rgb}, 0.06);
  padding: 16px 20px;
  animation: ${flow} 6s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
`;

const CardTitle = styled.h3`
  margin: 0;
  font-family: ${({ theme }) => theme.metrics.font.family};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Body = styled.div`
  min-width: 0;
`;

export default function HaShimmerCard({ title, fileName, children, exportBackground }) {
  const bodyRef = useRef(null);

  // Karttaki İLK svg dışa aktarılır — her kartın grafiği tek SVG (stat tile'lar dahil, hepsi
  // SVG olarak çizilir ki "her kart PNG indirilebilir" sözü tile'larda da tutsun).
  const handleDownload = () => {
    const svg = bodyRef.current?.querySelector('svg');
    if (!svg) return;
    downloadSvgAsPng(svg, {
      fileName,
      background: exportBackground || '#ffffff',
    }).catch(() => {}); // indirme hatası sessiz — API hatası değil, toast kuralı dışı
  };

  return (
    <Frame data-role="ha-dash-card">
      <Head>
        <CardTitle>{title}</CardTitle>
        <PngDownloadButton dataRole="ha-dash-download" onClick={handleDownload} />
      </Head>
      <Body ref={bodyRef}>{children}</Body>
    </Frame>
  );
}
